import * as angular from 'angular';
import { LoggedInUser } from '../custom';

export class AuthService {
    public userLoginPromise: ng.IDeferred<LoginResult> = this.$q.defer();

    /**
     * An array of attributes that will be saved of the authenticated user.
     */
    private USER_INFORMATION_NODES: string[] = [
        'firstName',
        'lastName',
        'email',
        'salutation',
        'referenceId',
        'role',
        'shipperName',
        'tsoName',
        'userId',
        'trackingSettings'
    ];

    constructor(
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private storageService: any,
        private USER_AUTH_FLAG: any
    ) {}

    /** @deprecated Please use {@link getLoggedInUser}. */
    public isLoggedIn(): boolean {
        let userAuthFlagFromSessionStore;
        try {
            userAuthFlagFromSessionStore =
                this.parseAuthFlagFromSessionStorage();
        } catch (e) {
            return false;
        }

        if (!userAuthFlagFromSessionStore) {
            return false;
        }

        for (let i = 0; i < this.USER_INFORMATION_NODES.length; i++) {
            if (
                !userAuthFlagFromSessionStore[this.USER_INFORMATION_NODES[i]] &&
                this.USER_INFORMATION_NODES[i] != 'shipperName' &&
                this.USER_INFORMATION_NODES[i] != 'tsoName'
            ) {
                return false;
            }
        }

        return true;
    }

    public logIn(userInformation): void {
        let userInformationToStore = {};

        for (let i = 0; i < this.USER_INFORMATION_NODES.length; i++) {
            userInformationToStore[this.USER_INFORMATION_NODES[i]] =
                userInformation[this.USER_INFORMATION_NODES[i]];
        }

        this.storageService.storeToSession(
            this.USER_AUTH_FLAG,
            btoa(encodeURIComponent(JSON.stringify(userInformationToStore)))
        );
    }

    public getLoggedInUser(): LoggedInUser {
        try {
            return this.parseAuthFlagFromSessionStorage();
        } catch (e) {
            return null;
        }
    }

    /**
     * @deprecated Use {@link userLoginPromise} instead (see {@link app.AuctionBidCtrl} as example)
     *  as this won't work in new tabs.
     */
    public getLoggedInUserAsync(): ng.IPromise<LoggedInUser> {
        return this.$timeout(() => this.getLoggedInUser());
    }

    public logOut(): void {
        this.storageService.removeFromSession(this.USER_AUTH_FLAG);
        this.storageService.clearSessionStorage();
        this.storageService.cleanLocalStorage();
    }

    private parseAuthFlagFromSessionStorage(): LoggedInUser {
        return JSON.parse(
            decodeURIComponent(
                atob(this.storageService.fetchFromSession(this.USER_AUTH_FLAG))
            )
        );
    }
}

angular.module('app').service('authService', AuthService);
